
import {Component, Vue} from "vue-property-decorator";
import SiteHeader from "@/components/UI/renewal/SiteHeader.vue";
import TemplateFooter from "@/components/UI/templates/TemplateFooter.vue";

@Component({
  components: {
    SiteHeader,
    TemplateFooter,
  },
})
export default class ContentPageLayout extends Vue {
}
